import { getPlatformComponent } from '@direct-frontend/platform-code';

export const OverlayContent = getPlatformComponent({
    desktop: import('./OverlayContent@desktop'),
    mobile: import('./OverlayContent@mobile'),
});
